/*
 * @Description: 公共 js
 * @Author: 裴孚
 * @Date: 2022-11-14 18:22:48
 * @LastEditors: PF
 * @LastEditTime: 2024-01-12 09:53:40
 * @FilePath: \NBBG\src\utils\index.js
 */

// 右键菜单关闭标签 [id]右键点击ID [currentId]当前选中ID [idType]当前选中ID [type]右键菜单类型 [listType]标签类型 [list]列表
export function youJianCaiDanGuanBiGiaoQian (id, currentId, idType, type, listType, list, callback) {
  const index = list.findIndex((item) => item.id === id)
  const currentIndex = list.findIndex((item) => item.id === currentId)
  switch (type) {
    case 'zuoce':
      list.splice(0, index)
      sessionStorage.setItem(listType, JSON.stringify(list))
      if (currentIndex < index) {
        sessionStorage.setItem(idType, id)
        if (callback) {
          callback()
        }
      }
      break
    case 'youce':
      list.splice(index + 1)
      sessionStorage.setItem(listType, JSON.stringify(list))
      if (currentIndex > index) {
        sessionStorage.setItem(idType, id)
        if (callback) {
          callback()
        }
      }
      break
    case 'quanbu':
      list = []
      sessionStorage.setItem(listType, JSON.stringify(list))
      if (callback) {
        sessionStorage.setItem(idType, 1)
        callback()
      } break
    case 'qita':
      list = [list[index]]
      sessionStorage.setItem(listType, JSON.stringify(list))
      sessionStorage.setItem(idType, id)
      if (callback) {
        callback(id)
      }
      break
  }
}
/**
 * 当前日期
 * @param {*} year YYYY
 * @param {*} month MM
 * @param {*} date DD
 * @param {*} hours HH
 * @param {*} minutes mm
 * @param {*} seconds ss
 * @returns getDate(null, 'MM', 'DD', null, null, null, null) 如只显示后面内容，前面必须有占位
 * @returns getDate('YYYY', 'MM', 'DD', 'HH', 'mm', 'ss') 完整版
 */
export function getDate (year, month, date, hours, minutes, seconds) {
  const now = new Date()
  year = year ? now.getFullYear() : undefined // 得到年份
  month = month ? now.getMonth() + 1 : undefined // 得到月份
  date = date ? now.getDate() : undefined // 得到日期
  hours = hours ? now.getHours() : undefined // 得到时
  minutes = minutes ? now.getMinutes() : undefined // 得到分
  seconds = seconds ? now.getSeconds() : undefined // 得到秒

  date = date < 10 ? '0' + date : date
  month = month < 10 ? '0' + month : month
  hours = hours < 10 ? '0' + hours : hours
  minutes = minutes < 10 ? '0' + minutes : minutes
  seconds = seconds < 10 ? '0' + seconds : seconds

  const newData = (year || '') + (year && month ? '-' : '') + (month || '') + (month && date ? '-' : '') + (date || '') + (date && hours ? ' ' : '') + (hours || '') + (hours && minutes ? ':' : '') + (minutes || '') + (minutes && seconds ? ':' : '') + (seconds || '')
  const defaultDate = `${newData}`
  return defaultDate
}
// 获取当前周次
export function getWeek (date) {
  // date = formatTimebytype(date, 'yyyy-MM-dd');//将日期转换成yyyy-mm-dd格式
  date = date ? new Date(date) : this.getDate('YYYY', 'MM', 'DD')
  const date2 = new Date(date.getFullYear(), 0, 1)
  let day1 = date.getDay()
  if (day1 === 0) day1 = 7
  let day2 = date2.getDay()
  if (day2 === 0) day2 = 7
  const d = Math.round((date.getTime() - date2.getTime() + (day2 - day1) * (24 * 60 * 60 * 1000)) / 86400000)
  // 当周数大于52则为下一年的第一周
  if ((Math.ceil(d / 7) + 1) > 52) {
    return (date.getFullYear() + 1) + '第1周'
  }
  return (Math.ceil(d / 7) + 1)
}

// 获取当前星期
export function getWeeks () {
  const weeks = ['日', '一', '二', '三', '四', '五', '六']
  const day = new Date().getDay()
  return '星期' + weeks[day]
}

// 浮点型相加
export function accAdd (arg1, arg2) {
  let r1, r2
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  }
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  }
  const m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

// 阿拉伯数字转中文数字
export function toChinesNum (num) {
  const changeNum = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const unit = ['', '十', '百', '千', '万', '亿']
  num = parseInt(num)
  const getWan = (temp) => {
    const strArr = temp.toString().split('').reverse()
    let newNum = ''
    const newArr = []
    strArr.forEach((item, index) => {
      newArr.unshift(item === '0' ? changeNum[item] : changeNum[item] + unit[index])
    })
    const numArr = []
    newArr.forEach((m, n) => {
      if (m !== '零') numArr.push(n)
    })
    if (newArr.length > 1) {
      newArr.forEach((m, n) => {
        if (newArr[newArr.length - 1] === '零') {
          if (n <= numArr[numArr.length - 1]) {
            newNum += m
          }
        } else {
          newNum += m
        }
      })
    } else {
      newNum = newArr[0]
    }
    return newNum
  }
  const overWan = Math.floor(num / 10000)
  let noWan = num % 10000
  if (noWan.toString().length < 4) {
    noWan = '0' + noWan
  }
  return overWan ? getWan(overWan) + '万' + getWan(noWan) : getWan(num)
}

/**
 * 合并相同数据，导出合并列所需的方法(只适合el-table)
 * @param {Object} data
 * @param {Object} rowspanArray
 */
export function getRowspanMethod (data, rowspanArray) {
  /**
   * 要合并列的数据
   */
  const rowspanNumObject = {}

  // 初始化 rowspanNumObject
  // eslint-disable-next-line array-callback-return
  rowspanArray.map((item) => {
    rowspanNumObject[item] = new Array(data.length).fill(1, 0, 1).fill(0, 1)
    rowspanNumObject[`${item}-index`] = 0
  })
  // 计算相关的合并信息
  for (let i = 1; i < data.length; i++) {
    // eslint-disable-next-line array-callback-return
    rowspanArray.map((key) => {
      const index = rowspanNumObject[`${key}-index`]
      if (data[i][key] === data[i - 1][key]) {
        rowspanNumObject[key][index]++
      } else {
        rowspanNumObject[`${key}-index`] = i
        rowspanNumObject[key][i] = 1
      }
    })
  }

  // 提供合并的方法并导出
  const spanMethod = function ({ row, column, rowIndex, columnIndex }) {
    if (rowspanArray.includes(column.property)) {
      const rowspan = rowspanNumObject[column.property][rowIndex]
      if (rowspan > 0) {
        return { rowspan: rowspan, colspan: 1 }
      }
      return { rowspan: 0, colspan: 0 }
    }
    return { rowspan: 1, colspan: 1 }
  }

  return spanMethod
}
// 天气
export function tianQi () {
  $.ajax({
    url: 'https://api.map.baidu.com/weather/v1/?district_id=110100&data_type=all&ak=jjchu764ZlVBkq8UEQdz5RrnpvLYi86n',
    type: 'GET',
    contentType: 'application/json; charset=utf-8',
    dataType: 'json',
    success: function (data) {
      console.log('token', data)
    }
  })
}

// 获取身份证中出生日期与性别
export function getBirth (idCard) {
  let birthday = ''
  const info = { csrq: '', xb: '' }
  if (idCard !== null && idCard !== '') {
    if (idCard.length === 15) {
      birthday = '19' + idCard.slice(6, 12)
    } else if (idCard.length === 18) {
      birthday = idCard.slice(6, 14)
    }
    info.csrq = birthday.replace(/(.{4})(.{2})/, '$1-$2-')
  }
  if (parseInt(idCard.slice(-2, -1)) % 2 === 1) {
    info.xb = '男'
  } else {
    info.xb = '女'
  }
  return info
}

// 计时器
export function getJiShi (isQingKong, callback) {
  let num = 0
  let timer = null
  if (isQingKong) {
    num = 0
  }
  timer = setInterval(() => {
    if (num >= 5) {
      const isShuaXin = true
      callback(isShuaXin)
      clearInterval(timer)
    } else {
      num++
    }
    console.log(num)
  }, 1000)
}
